<template>
    <div>

            <div class="row">
                <div class="col-md-6">
                    <VueInput :error="errors.default_width" label="Width" v-model="modelValues.default_width" />
                </div>
                <div class="col-md-6">
                   <VueInput :error="errors.default_unit_price" label="Unit Price" v-model="modelValues.default_unit_price" type="number" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <VueInput :error="errors.default_vat_per_unit" label="VAT / unit" v-model="modelValues.default_vat_per_unit" type="number" />
                </div>
                <div class="col-md-6">
                    <VueInput :error="errors.default_unit_price_total" label="Unit Price Total" type="number" v-model="modelValues.default_unit_price_total = calculateTotalPrice" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Unit</label>
                        <div class="col-sm-7">
                            <input v-if="showKnitUnitOnly" type="text" v-model="modelValues.default_unit" class="form-control" disabled readonly/>
                            <select v-else class="form-control" v-model="modelValues.default_unit">
                                <option value="m">Meter</option>
                                <option value="y">Yard</option>
                                <option value="kg">Kilogram</option>
                            </select>

                            <small v-if="errors.default_unit" class="form-text text-danger">{{errors.default_unit.join(' ')}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Currency</label>
                        <div class="col-sm-7 text-right">
                            <select class="form-control" v-model="modelValues.default_currency">
                                <option value="THB">Thai Baht</option>
                                <option value="USD">US Dollar</option>
                            </select>
                            <small v-if="errors.currency" class="form-text text-danger">{{errors.currency.join(' ')}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <hr/>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">Supplier</label>
                        <div class="col-sm-9">
                            <v-select placeholder="Choose One" v-model="modelValues.current_fabric_supplier_id" :options="fieldValues.suppliers" label="name" :reduce="supplier => supplier.id" />
                            <small v-if="errors.current_fabric_supplier_id" class="form-text text-danger">{{errors.current_fabric_supplier_id.join(' ')}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">Supplier Code</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="modelValues.current_fabric_supplier_code">
                            <small v-if="errors.current_fabric_supplier_code" class="form-text text-danger">{{errors.current_fabric_supplier_code.join(' ')}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <hr/>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Fabric Types</label>
                        <div class="col-sm-7">
                            <v-select placeholder="Choose One" v-model="modelValues.type" :options="fieldValues.fabricTypes" @input="updateSampleBook()" />
                            <small v-if="errors.type" class="form-text text-danger">{{errors.type.join(' ')}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Matching</label>
                        <div class="col-sm-7">
                                <select class="form-control" v-model="modelValues.matching">
                                    <option value=1 >Yes</option>
                                    <option value=0 >No</option>
                                </select>
                               <small v-if="errors.matching" class="form-text text-danger">{{errors.matching.join(' ')}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Suitable for</label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="modelValues.gender_suitable_for">
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </select>
                            <small v-if="errors.gender_suitable_for" class="form-text text-danger">{{errors.gender_suitable_for.join(' ')}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Stretch</label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="modelValues.is_stretch_fabric">
                                <option value=1>Yes</option>
                                <option value=0>No</option>
                            </select>
                            <small v-if="errors.is_stretch_fabric" class="form-text text-danger">{{errors.is_stretch_fabric.join(' ')}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Design Extra</label>
                        <div class="col-sm-7">
                              <input type="number" class="form-control" v-model="modelValues.design_extra">
                              <small v-if="errors.design_extra" class="form-text text-danger">{{errors.design_extra.join(' ')}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Jersey</label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="modelValues.is_jersey_fabric" @change="onJerseyFabricChange">
                                <option value=1>Yes</option>
                                <option value=0>No</option>
                            </select>
                            <small v-if="errors.is_jersey_fabric" class="form-text text-danger">{{errors.is_jersey_fabric.join(' ')}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Shirt Fabric</label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="modelValues.is_shirt_fabric">
                                <option value=1>Yes</option>
                                <option value=0>No</option>
                            </select>
                            <small v-if="errors.is_shirt_fabric" class="form-text text-danger">{{errors.is_shirt_fabric.join(' ')}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Certificate</label>
                        <div class="col-sm-7">
                                <v-select placeholder="No certificate" v-model="modelValues.certificate" :options="fieldValues.certificates" />
                               <small v-if="errors.certificate" class="form-text text-danger">{{errors.certificate.join(' ')}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Interlining Color</label>
                        <div class="col-sm-7">
                                <select class="form-control" v-model="modelValues.interlining_color">
                                    <option v-for="interlining in fieldValues.interliningColors" :value="interlining.code" >
                                      {{ interlining.name_en }}
                                    </option>
                                </select>
                               <small v-if="errors.interlining_color" class="form-text text-danger">{{errors.interlining_color.join(' ')}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Interlining</label>
                        <div class="col-sm-7">
                                <select class="form-control" v-model="modelValues.interlining">
                                    <option v-for="interlining in fieldValues.interlinings" :value='interlining.code' >
                                      {{ interlining.code }}
                                    </option>
                                </select>
                               <small v-if="errors.interlining" class="form-text text-danger">{{errors.interlining.join(' ')}}</small>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Repetition Warp ( cm )</label>
                        <div class="col-sm-7">
                            <input @keypress="isNumber" type="number" class="form-control" v-model="modelValues.repetition_wrap">
                            <small v-if="errors.repetition_wrap" class="form-text text-danger">{{errors.repetition_wrap.join(' ')}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Repetition Weft ( cm )</label>
                        <div class="col-sm-7">
                            <input @keypress="isNumber" type="number" class="form-control" v-model="modelValues.repetition_weft">
                            <small v-if="errors.repetition_weft" class="form-text text-danger">{{errors.repetition_weft.join(' ')}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label class="col-sm-5 col-form-label">Usable Width  ( cm )</label>
                        <div class="col-sm-7">
                            <input @keypress="isNumber" type="number" class="form-control" v-model.number="modelValues.usable_width">
                            <small v-if="errors.usable_width" class="form-text text-danger">{{errors.usable_width.join(' ')}}</small>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import VueInput from "@/pages/Tools/input";

export default {
  components: {
    VueSlider,
    VueInput,
  },
  data() {
    return {
        showKnitUnitOnly: false,
        originalNonKnitUnit: 'm'
    }
  },
  computed: {
    calculateTotalPrice: function () {
      let defaultUnitPrice = parseFloat(this.modelValues.default_unit_price);
      let defaultVatPerUnit =
        parseFloat(this.modelValues.default_vat_per_unit) || 0;
      return defaultUnitPrice + defaultVatPerUnit;
    },
  },
  props: {
    fieldValues: {
      type: [Object],
      default: {},
    },
    modelValues: {
      type: [Object],
      default: {},
    },
    errors: {
      type: [Object],
      default: {},
    },
  },
  mounted() {
    if(this.modelValues.is_jersey_fabric == 0) {
      this.originalNonKnitUnit = this.modelValues.default_unit;
    }
    this.showKnitUnitOnly = (this.modelValues.is_jersey_fabric == 1);
  },
  methods: {
    updateSampleBook() {
      if (this.modelValues.type == "Main") {
        this.modelValues.sample_book = 1;
      } else {
        this.modelValues.sample_book = 0;
      }
    },
    isNumber(event) {
      const keysAllowed = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ".",
      ];
      const keyPressed = event.key;
      if (!keysAllowed.includes(keyPressed)) {
        event.preventDefault();
      }
    },
    onJerseyFabricChange() {
      if(this.modelValues.is_jersey_fabric == 1) {
        this.showKnitUnitOnly = true;
        this.originalNonKnitUnit = this.modelValues.default_unit;
        this.modelValues.default_unit = 'kg';
      } else {
        this.showKnitUnitOnly = false;
        this.modelValues.default_unit = this.originalNonKnitUnit;
      }
    }
  },
};
</script>

<style scoped>
label {
  margin-top: 7px !important;
}
</style>
